import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tile-button',
  templateUrl: './tile-button.component.html',
  styleUrl: './tile-button.component.scss'
})
export class TileButtonComponent {
  @Input() icon?: string;
  @Input() label?: string;
}
